import sObjetos from '@/aplicacao/_servicos/objetos'

function State() {
    this.tipo = ''
    this.mensagem = ''
    this.contador = 1
}

const mutations = {

    resetar(stateParam) {
        sObjetos.preencher(stateParam, new State())
    },

    setTipo(state, payload) {
        state.tipo = payload
    },

    setMensagem(state, payload) {
        state.mensagem = payload
    },

    setContador(state, payload) {
        state.contador = payload
    },

}

const actions = {

    resetar({ commit }, payload) {
        commit('resetar', payload)
    },

    setFlash({ commit, dispatch }, payload) {
        dispatch('resetar')
        commit('setTipo', 'success')
        commit('setMensagem', payload)
    },

    decrementarContador({ commit, state }, payload) {
        commit('setContador', --state.contador)
    },

    tratarRemocao({ commit, getters, dispatch }, payload) {
        if (getters['deveMostrar']) {
            dispatch('decrementarContador')
            if (getters['deveResetar']) {
                dispatch('resetar')
            }
        }
    },

}

const getters = {

    deveMostrar(state) {
        return '' !== state.mensagem
    },

    deveResetar(state) {
        return 0 === state.contador
    },

}

export default {
    state: new State(),
    mutations,
    actions,
    getters,
}
